import { render, staticRenderFns } from "./NotificationSettingsTab.vue?vue&type=template&id=504dbb82&scoped=true"
import script from "./NotificationSettingsTab.vue?vue&type=script&lang=js"
export * from "./NotificationSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./NotificationSettingsTab.vue?vue&type=style&index=0&id=504dbb82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504dbb82",
  null
  
)

export default component.exports